import { SortingState } from '@cast/design-system';

export const hasSortingStateChanged = (
  newState?: SortingState,
  oldState?: SortingState
): boolean => {
  return (
    newState?.columnId !== oldState?.columnId ||
    newState?.sortBy.direction !== oldState?.sortBy.direction
  );
};
